import React from 'react';
import './App.css';
import Koot from './Components/Koot'; // Correct import statement

function App() {
  return (
    <Koot />
  );
}

export default App;
